<template>
  <div class="autocomplete col-12">
    <div class="col-12 mt-4">
      <div class="input-group-append">
        <input
          name="search"
          v-model="searchText"
          type="search"
          @focus="onFocus"
          @input="autoComplete"
          @blur="closeSuggestions"
          class="form-control"
          placeholder="Practice name"
          autocomplete="off"
        />

      </div>
      <ul class="text-left list-group autocomplete-list" v-if="showSuggestion">
        <li
          v-for="s in suggestions"
          :key="s.id"
          @click="chosen(s)"
          @mousedown="suggestionFocus = true"
          class="list-group-item">
          <img v-if="s.logoImage" class="autocomplete-image" :src="`data:image/png;base64,${s.logoImage}`">
          <img v-else class="autocomplete-image" src="~assets/images/logbox_logo_sm.png"/>
         &emsp; {{ s.name }}</li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'practice-search',
  data() {
    return {
      searchText: '',
      suggestion: null,
      suggestions: null,
      suggestionFocus: false,
      showSuggestion: false,
    };
  },
  methods: {
    async autoComplete() {
      if (this.searchText.length <= 3) {
        return;
      }

      await this.$api.fetchPracticeNameAutocomplete(this.searchText).then((response) => {
        this.suggestions = response;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.suggestions = [{ id: null, name: error.response.statusText }];
          return;
        }
        this.suggestions = [{ id: null, name: 'An Error Occurred While Searching' }];
      });
    },
    chosen(suggestion) {
      if (suggestion.id !== null) {
        this.$emit('practice', suggestion);
      }
      this.searchText = suggestion.name;
      this.suggestion = suggestion;
      this.clearSuggestions();
    },
    closeSuggestions() {
      if (!this.suggestionFocus) {
        this.showSuggestion = false;
      }
    },
    onFocus() {
      this.suggestionFocus = false;
      this.showSuggestion = true;
    },
    clearSuggestions() {
      this.suggestions = null;
    },
  },
  mounted() {
    this.autoComplete();
  },
};
</script>



// WEBPACK FOOTER //
// PracticeSearch.vue?3ca007f0